import cms from 'apis/cms';
import { CustomTagProps } from 'types/CustomTagProps';
import { showToast } from 'utils/showToast';

export async function deleteTag(newTag: CustomTagProps, toast: any, t: any) {
  let isSuccess = false;

  await cms.rest
    .delete(`promotional-tags/${newTag.id}`)
    .then(() => {
      isSuccess = true;
      showToast(
        toast,
        'customTags.success',
        'customTags.successDelete',
        'success',
        t,
      );
    })
    .catch(() => {
      isSuccess = false;
      showToast(toast, 'customTags.erro', 'customTags.erroDelete', 'error', t);
    });

  return isSuccess;
}

export async function activeTag(newTag: CustomTagProps, id: string) {
  let isSuccess = false;
  const payload: any = structuredClone(newTag);
  delete payload.id;
  delete payload.created_at;
  delete payload.updated_at;
  delete payload.file;

  await cms.rest
    .patch(`promotional-tags/${id}`, payload)
    .then(() => {
      isSuccess = true;
    })
    .catch(() => {
      isSuccess = false;
    });

  return isSuccess;
}
